import { render, staticRenderFns } from "./CobrancaInfos.vue?vue&type=template&id=0ce9344e&scoped=true"
import script from "./CobrancaInfos.vue?vue&type=script&lang=js"
export * from "./CobrancaInfos.vue?vue&type=script&lang=js"
import style0 from "./CobrancaInfos.vue?vue&type=style&index=0&id=0ce9344e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce9344e",
  null
  
)

export default component.exports